import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import config from '../siteConfig';

const PostHeader = props => {
  const { frontMatter } = props;
  const postPath = `${config.routePosts}/${frontMatter.slug}`;

  return (
    <header className="blog-post--header">
      <h1 className="blog-post-title">
        <Link to={postPath} rel="bookmark">
          {frontMatter.title}
        </Link>
      </h1>
      <div className="blog-post-meta">
        <time dateTime={frontMatter.datePublishedRaw}>{frontMatter.datePublishedFormatted}</time>
        {' By '}
        <span>{frontMatter.author}</span>
        <div className="entry-comments-link">
          <Link to={`${postPath}/#disqus_thread`}>Comments</Link>
        </div>
      </div>
    </header>
  );
};

PostHeader.propTypes = {
  frontMatter: PropTypes.shape({
    author: PropTypes.string,
    datePublishedFormatted: PropTypes.string,
    datePublishedRaw: PropTypes.number,
    slug: PropTypes.string,
    title: PropTypes.string,
  }),
};

PostHeader.defaultProps = {
  frontMatter: {
    author: '',
    datePublishedFormatted: '',
    datePublishedRaw: Date.now(),
    slug: '',
    title: '',
  },
};

export default PostHeader;



// WEBPACK FOOTER //
// ./src/components/PostHeader.js